import { render, staticRenderFns } from "./AgreementDetails.vue?vue&type=template&id=5c71c2ec"
import script from "./AgreementDetails.vue?vue&type=script&lang=js"
export * from "./AgreementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports